import { mapActions } from "vuex";

export default {
  methods: {
    handleErrorStatus(status) {
      switch (status) {
        case 401:
          this.clearSession();
          this.snackbarInvalidToken();
          this.$router.push("/login");
          break;
        case 403:
          this.snackbarError("Insufficient rights");
          this.snackbarError(this.$t("insufficientRights"));
          break;
        default:
          this.snackbarError(this.$t("loadingDataFailed"));
          break;
      }
    },
    ...mapActions(["clearSession"]),
  },
};
